import { render } from "./OwnerThoughtList.vue?vue&type=template&id=c3d95c98&scoped=true"
import script from "./OwnerThoughtList.vue?vue&type=script&lang=js"
export * from "./OwnerThoughtList.vue?vue&type=script&lang=js"

import "./OwnerThoughtList.vue?vue&type=style&index=0&id=c3d95c98&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3d95c98"]])

export default __exports__